import { cloneElement, useCallback, useEffect, useState } from "react";
import InfoIcon from "../clinks/info/InfoIcon";

interface ValidationsWrapperProps {
  name: string;
  min?: number;
  max?: number;
  required?: boolean;
  defaultDirty?: boolean;
  isAutocomplete?: boolean;
  index?: number;
  setValidations?: any;
  value: string|number|Array<string|number|Object>;
  iconStyle?: {[key:string]:string};
  style?: {[key:string]:string};
  children: JSX.Element;
}

const checkRequired = (value:string|number|Array<string|number|Object>) => {
  if (typeof value === "object") {
    if (isNaN(value.length) || value.length === 0) {
      return false;
    }
  } else {
    const numberValue = Number(value);
    if (isNaN(numberValue)) return false;
  }
  return true;
}

const iconStyles = { position: "absolute", top: "5px", float:"right", right: "2px"};

function ValidationsWrapper(props:ValidationsWrapperProps) {
  const [isValid, setIsValid] = useState<boolean>(false);
  const [isDirty, setIsDirty] = useState<boolean>(props.defaultDirty ? props.defaultDirty :false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleBlur = () => {
    setIsDirty(true);
    checkIsValid();
  }

  const checkIsValid = useCallback(() => {
    const { name, min, max, value, required, index, setValidations } = props;

    const selectedIndex = index === undefined ? 0 : index;
    let newIsValid = true;

    if (required && !checkRequired(value)) {
      newIsValid = false;
      setErrorMessage("Required");
    } else if (typeof value !== "object" && (min || max)) {
      const numberValue = Number(value);
      if (min && numberValue < min) {
        newIsValid = false;
        setErrorMessage("Value should be greater than or equal to " + min);
      }
      if (max && numberValue > max) {
        newIsValid = false;
        setErrorMessage("Value should be less than or equal to " + max);
      }
    }

    if (newIsValid !== isValid) {
      if (setValidations) {
        setValidations((prevValidations:any) =>{
          return prevValidations.map((validation:any, vIndex:number) => {
            if (vIndex === selectedIndex) {
              return {...validation, [name]: newIsValid};
            } else {
              return validation;
            }
          });
        });
      }
    }
    setIsValid(newIsValid);
    if (newIsValid) setErrorMessage("");
  }, [ props, isValid ]);

  useEffect(() => {
    checkIsValid();
  }, [checkIsValid]);

  return (
    <div style={{ ...props.style, position: "relative" }}>
      {(() => {
        return cloneElement(props.children, {
          onBlur: handleBlur,
          className: isDirty && !isValid && !props.isAutocomplete ? "form-control-error" : "",
          style: isDirty && !isValid && props.isAutocomplete ? { border: "1px solid red", borderRadius: "0.2rem", boxShadow: "0 0 0 .2rem rgba(255,0,0, 35%)" } : null
        })
      })()}
      {
        isDirty && !isValid ? 
          <InfoIcon style={{ ...iconStyles, ...props.iconStyle }} isWarning>
            <div>{errorMessage}</div>
          </InfoIcon> 
        : null 
      }
    </div>
  );
};

export default ValidationsWrapper;
